export default __webpack_public_path__ + "static/media/hood_3.30001acf.png";